import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

const LIST_A = ["TALENT", "BRANDS", "OPPORTUNITIES", "GLOBAL REACH"];
const LIST_B = ["PEOPLE", "IDEAS", "OPPORTUNITIES", "RESULTS"];

export const BrandStatement = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [30, -30]);

  return (
    <section
      ref={ref}
      className="relative overflow-hidden border-y border-dealer-ivory/10 py-32 sm:py-48"
      data-testid="brand-statement-section"
    >
      <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
        <motion.h2
          style={{ y }}
          className="font-serif text-4xl leading-[1.08] tracking-tight text-dealer-ivory sm:text-5xl lg:text-6xl"
        >
          <Reveal>
            <span className="block">DISCIPLINE</span>
          </Reveal>
          <Reveal delay={0.1}>
            <span className="block">CREATES</span>
          </Reveal>
          <Reveal delay={0.2}>
            <span className="block text-dealer-burgundybright">
              OPPORTUNITY.
            </span>
          </Reveal>
        </motion.h2>

        <div className="mt-20 grid gap-12 md:grid-cols-2">
          <Reveal delay={0.2}>
            <p className="font-sans text-[11px] font-medium leading-[2.6] tracking-[0.35em] text-dealer-silver">
              {LIST_A.map((w, i) => (
                <span key={w}>
                  {w}
                  {i < LIST_A.length - 1 && (
                    <span className="mx-4 text-dealer-burgundybright">/</span>
                  )}
                </span>
              ))}
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="font-sans text-[11px] font-medium leading-[2.6] tracking-[0.35em] text-dealer-silver md:text-right">
              {LIST_B.map((w, i) => (
                <span key={w}>
                  {w}
                  {i < LIST_B.length - 1 && (
                    <span className="mx-4 text-dealer-burgundybright">/</span>
                  )}
                </span>
              ))}
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.4}>
          <div className="mt-20 flex items-center gap-6">
            <span className="block h-px w-16 bg-dealer-burgundybright" />
            <p
              className="font-serif text-lg italic tracking-[0.06em] text-dealer-ivory/80 sm:text-xl"
              data-testid="brand-line"
            >
              WE ARE THE DEAL.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
